import { ref, onMounted, onUnmounted } from 'vue'
import { supabase } from '../lib/supabase'
import type { User } from '@supabase/supabase-js'

export function useAuth() {
  const user = ref<User | null>(null)
  const loading = ref(true)

  // Obtener la sesión actual
  const getSession = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession()
      user.value = session?.user ?? null
    } catch (error) {
      console.error('Error al obtener sesión:', error)
      user.value = null
    } finally {
      loading.value = false
    }
  }

  // Escuchar cambios en la autenticación
  const { data: { subscription } } = supabase.auth.onAuthStateChange(
    async (event, session) => {
      user.value = session?.user ?? null
      loading.value = false
    }
  )

  // Cerrar sesión
  const signOut = async () => {
    try {
      await supabase.auth.signOut()
      user.value = null
    } catch (error) {
      console.error('Error al cerrar sesión:', error)
    }
  }

  // Limpiar suscripción al desmontar
  onUnmounted(() => {
    subscription.unsubscribe()
  })

  // Obtener sesión inicial
  onMounted(() => {
    getSession()
  })

  return {
    user,
    loading,
    signOut,
    isAuthenticated: () => !!user.value
  }
} 